export function setEtapas(state, etapas) {
    state.etapas = etapas;
}

export function setEtapaSelec(state, etapa) {
    state.etapaSelec = etapa;
}

export function actListEtapas(state, etapa) {
    if (etapa !== null) {
        const index = state.etapas.findIndex(r => r.id === etapa.id)
        if (index != -1) {
            state.etapas[index].titulo = etapa.titulo;  
            state.etapas[index].descripcion = etapa.descripcion;  
            state.etapas[index].descripcion_EN = etapa.descripcion_EN;
            state.etapas[index].descripcion_DE = etapa.descripcion_DE;
            state.etapas[index].imagen_base64 = etapa.imagen_base64;
            state.etapas[index].inicio_punto = etapa.inicio_punto;
            state.etapas[index].final_punto = etapa.final_punto;
            state.etapas[index].dificultad = etapa.dificultad;
            state.etapas[index].distancia = etapa.distancia;
            state.etapas[index].duracion = etapa.duracion;
        }
    }
}

export function actDeleteListEtapas(state, id) {
    if (id != null) {
        const index = state.etapas.findIndex(r => r.id === id)
        if (index != -1) {
            state.etapas.splice(index, 1)
        }
    }
}